import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  OptionAwardService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-award-services';
import ToastComponent from '../../components/toast';

const usePostReCalculateISOValues = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onDone?: (success: boolean) => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (id: string) => {
      if (id != null || id !== '') {
        return await handleRequest(
          OptionAwardService.postApiAwardApiAppOptionAwardReCalculateIsoValues(id)
        );
      }
    },
    {
      onSuccess: async (response) => {
        if (response?.isSuccess) {
          await queryClient.invalidateQueries('getISOQualifiedListByParticipantId');
          toast.success(<ToastComponent label='Success' message={`ISO values re-calculated.`} />);
          if (onDone) onDone(true);
        } else {
          if (onDone) onDone(false);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostReCalculateISOValues;
